



















import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Scope } from 'spraypaint';
import { ApplicationRecord } from '@/api';
import { debounce } from 'lodash';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ default: '' })
  readonly label: string;

  @Prop({ default: '' })
  readonly placeholder: string;

  @Prop({ default: 'name' })
  readonly itemText: string;

  @Prop({ default: 'id' })
  readonly itemValue: string;

  @Prop({})
  readonly emptyFieldText: string;

  @Prop({})
  readonly noResultsText: string;

  @Prop({ default: false })
  readonly clearable: boolean;

  @Prop({ required: false })
  readonly rules: any;

  @Prop({ required: true })
  readonly scopeFactory: () => Scope<ApplicationRecord>;

  @Prop({})
  readonly scopeWhere: any;

  @Model('input', { type: ApplicationRecord })
  readonly value: ApplicationRecord | null;

  get selected() {
    return this.value;
  }

  set selected(d) {
    this.$emit('input', d);
  }

  get noDataText() {
    if (this.noResultsText && this.didSearch) {
      return this.noResultsText;
    } else {
      return this.emptyFieldText;
    }
  }

  loading: boolean = false;
  didSearch: boolean = false;
  updateForced: boolean = false;

  search: string | null = null;

  items: ApplicationRecord[] = [];

  update: () => void;

  async doUpdate(forceUpdate: boolean = false) {
    if (this.loading) {
      return;
    }

    if (forceUpdate && this.selected) {
      this.updateForced = true;
      this.items = [this.selected];
    } else {
      try {
        this.loading = true;
        if (this.search) {
          let where = { search: this.search };
          if (this.scopeWhere) {
            where = Object.assign(this.scopeWhere, where);
          }
          const scope = this.scopeFactory().where(where);
          const result = await scope.all();
          this.items = result.data;
          this.didSearch = true;
        } else {
          this.didSearch = false;
        }
      } catch (e) {
        this.items = [];
      } finally {
        this.loading = false;
      }
    }
  }

  mounted() {
    this.doUpdate(true);
    this.update = debounce(this.doUpdate, 500);
  }

  @Watch('search')
  searchChanged() {
    if (this.updateForced) {
      this.updateForced = false;
    } else {
      this.update();
    }
  }

  @Watch('scopeWhere')
  scopeChanged() {
    this.update();
  }
}
